import { FormControl as MuiFormControl, FormControlProps } from '@mui/material';

const FormControl = (props: FormControlProps) => (
  <MuiFormControl fullWidth sx={{ m: 1, marginLeft: 0, marginRight: 0 }} {...props}>
    {props?.children}
  </MuiFormControl>
);

export default FormControl;
